import React, { useContext, useEffect, useState } from "react";
import { SimpleGrid, Button } from "@chakra-ui/react";
import { FiGitBranch } from "react-icons/fi";
import ConfirmationButton from "./buttons/ConfirmationButton";
import TeamButton from "../components/buttons/TeamButton";
import TaskTypeButton from "../components/buttons/TaskTypeButton";
import CreateAppointmentButton from "./buttons/CreateAppointmentButton";
import CreateServiceModalButton from "./buttons/CreateServiceModalButton";
import AuthContext from "../contexts/Auth";
import client from "../helpers/Client";

function TaskActions({
  handleDelete,
  handleStart,
  handleComplete,
  handleApprove,
  handleAssign,
  handleSetType,
  handleSetAppointment,
  handleCancelAppointment,
  handleSetService,
  handleCreateSubtask,
  task,
}) {
  const auth = useContext(AuthContext);
  const isSuperUser = !!auth?.data?.user?.is_superuser;
  const userRoles = {
    manager: !!auth?.data?.user?.employee?.is_manager,
    servicer: !!auth?.data?.user?.is_servicer,
    technical: !!auth?.data?.user?.is_technical,
    reseller: !!auth?.data?.user?.is_reseller,
    employee: !!auth?.data?.user?.is_employee,
  };
  const [disabledButtons, setDisabledButtons] = useState(new Set());
  useEffect(() => {
    const load = async () => {
      try {
        if (isSuperUser) { setDisabledButtons(new Set()); return; }
        const roles = Object.entries(userRoles).filter(([_, v]) => v).map(([k]) => k);
        if (!roles.length) { setDisabledButtons(new Set()); return; }
        const { data } = await client.get(`/config/role-pages/?enabled=false`);
        const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
        const disabled = arr.filter(it => roles.includes(it.role_code) && it.button_id).map(it => it.button_id);
        setDisabledButtons(new Set(disabled));
      } catch (_) {
        setDisabledButtons(new Set());
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuperUser]);
  const allow = (id) => isSuperUser || !disabledButtons.has(id);
  return (
    <SimpleGrid
      columns={{ base: 1, sm: 2, md: 4, lg: 4, xl: 4 }}
      gap={1}
    >
      {!task.started_at && (
        <ConfirmationButton
          callback={handleStart}
          title="Başlat"
          verb="başlatmak"
          buttonColor="green"
          buttonVariant={task.started_at ? "solid" : "outline"}
          buttonTitle="BAŞLAT"
          isVisible={allow('task.action.start')}
        />
      )}
      {task.started_at && !task.completed_at && (
        <ConfirmationButton
          callback={handleComplete}
          title="Tamamla"
          verb="tamamlamak"
          buttonColor="green.600"
          buttonVariant={task.completed_at ? "solid" : "outline"}
          buttonTitle="TAMAMLA"
          isVisible={allow('task.action.complete')}
        />
      )}
      {task.completed_at && (
        <ConfirmationButton
          isDisabled={task.approved_at}
          callback={handleApprove}
          title={task.approved_at ? "Onaylandı" : "Onayla"}
          verb="tamamlamak"
          buttonColor="whatsapp"
          buttonVariant={task.approved_at ? "solid" : "outline"}
          buttonTitle={"İşlemleri Onayla"}
          isVisible={allow('task.action.approve')}
        />
      )}
      <TaskTypeButton
        variant="outline"
        colorScheme="blue"
        size="sm"
        task={task}
        onClick={() => handleSetType(task)}
        hidden={!allow('task.action.set_type')}
      />
      <CreateAppointmentButton
        buttonVariant="outline"
        colorScheme="blue"
        size="sm"
        task={task}
        onClick={() => handleSetAppointment(task)}
        isVisible={allow('task.action.set_appointment')}
      />
      <ConfirmationButton
        callback={handleCancelAppointment}
        buttonVariant="outline"
        buttonColor="red"
        size="sm"
        title="Rand. İptal Et"
        verb="randevuyu iptal"
        buttonTitle="Randevuyu İptal Et"
        isDisabled={!Boolean(task.appointment_date)}
        isVisible={allow('task.action.cancel_appointment')}
      />
      <CreateServiceModalButton
        buttonVariant="outline"
        colorScheme="blue"
        size="sm"
        task={task}
        onClick={() => handleSetService(task)}
        isVisible={allow('task.action.set_service')}
      />
      <TeamButton
        buttonVariant="outline"
        colorScheme="blue"
        size="sm"
        task={task}
        onClick={() => handleAssign(task)}
        hidden={!allow('task.action.assign_team')}
      />
      {handleCreateSubtask && (
        <Button
          leftIcon={<FiGitBranch />}
          variant="outline"
          colorScheme="green"
          size="sm"
          onClick={() => handleCreateSubtask(task)}
          hidden={!allow('task.action.create_subtask')}
        >
        Alt Görev Ekle
      </Button>
    )}
    <ConfirmationButton
        callback={handleDelete}
        title="Görevi Sil"
        verb="silmek"
        buttonColor="red"
        buttonVariant={task.deleted_at ? "solid" : "outline"}
        buttonTitle="SİL"
        isVisible={allow('task.action.delete')}
      />
    </SimpleGrid>
  );
}

export default TaskActions;
